import AccountBoxIcon from '@mui/icons-material/AccountBox'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import DomainAddIcon from '@mui/icons-material/DomainAdd'
import MediationIcon from '@mui/icons-material/Mediation'
import PinInvokeIcon from '@mui/icons-material/PinInvoke'

export { generateTabs }

const generateTabs = ({
  canViewActiviteiten,
  hasAlgemeneBijlagen,
  canViewSubprocessen,
}) => {
  const tabs = [
    { label: 'Gegevens', id: 'gegevens', icon: <DocumentScannerIcon /> },
    {
      label: 'Contactpersonen',
      id: 'contactpersonen',
      icon: <AccountBoxIcon />,
    },
  ]

  if (canViewActiviteiten) {
    tabs.push({
      label: 'Activiteiten',
      id: 'activiteiten',
      icon: <PinInvokeIcon />,
    })
  }

  if (hasAlgemeneBijlagen) {
    tabs.push({
      label: 'Algemene bijlagen',
      id: 'algemene-bijlagen',
      icon: <AttachFileIcon />,
    })
  }

  tabs.push({
    label: 'Bijlagen',
    id: 'bijlagen',
    icon: <AttachFileIcon />,
  })

  if (canViewSubprocessen) {
    tabs.push({
      label: 'Subprocessen',
      id: 'subprocessen',
      icon: <AccountTreeIcon />,
    })
  }

  tabs.push(
    { label: 'Disciplines', id: 'disciplines', icon: <MediationIcon /> },
    { label: 'Opdrachten', id: 'opdrachten', icon: <AssignmentIcon /> },
    {
      label: 'Projectafhankelijkheden',
      id: 'projectafhankelijkheden',
      icon: <DomainAddIcon />,
    },
  )

  return tabs
}
